import http from "@/api/http/http";
import axios from "axios";

export default {
  post (uri: string ,params: any, cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    axios.post(`${process.env.VUE_APP_API}${uri}`, params, header)
      .then(cb)
      .catch(errCb)
  },
  get(uri: string ,params: any, cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&')
    axios.get(`${process.env.VUE_APP_API}${uri}?${payloadString}`, header)
      .then(cb)
      .catch(errCb)
  },
  put(uri: string ,params: any, cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    axios.put(`${process.env.VUE_APP_API}${uri}`, params, header)
      .then(cb)
      .catch(errCb)
  },
  delete(uri: string , cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}${uri}`, header)
      .then(cb)
      .catch(errCb)
  },
  patch(uri: string ,params: any, cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    axios.patch(`${process.env.VUE_APP_API}${uri}`, params, header)
      .then(cb)
      .catch(errCb)
  },
  postWithFile(uri: string ,params: any, cb: (response) => any, errCb: (response) => any) {
    const header = http.setHeaders()
    axios.post(`${process.env.VUE_APP_API}${uri}`, params, header)
      .then(cb)
      .catch(error => {
        if (error.response && error.response.data && error.response.data.message) {
          errCb(error.response.data);
        } else {
          errCb({ message: "An unknown error occurred" });
        }
      })
  },
  excelDownload(uri: string, params: any, cb: (response) => any, errCb: (response) => any) {
    const accessToken = localStorage.ACCESS_TOKEN
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&')
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}${uri}?${payloadString}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
      .then(cb)
      .catch(errCb)
  }
}

const convertKeysToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(v => convertKeysToCamelCase(v)) as any
  } else if (obj !== null && typeof obj === "object") {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const camelKey = key.replace(/_([a-z0-9])/g, (_, letter) => letter.toUpperCase()) as keyof any
      return {...acc, [camelKey]: convertKeysToCamelCase(value)} as any
    }, {}) as any
  }
  return obj as any
}